module.exports = __webpack_public_path__ + "static/media/karim-adib.99697b02.jpg";